import styled from "styled-components";

import Link from "core/Link";
import BodyText from "core/BodyText";

import { convertPxToRem } from "frontend/components/helpers";

export const UploadName = styled(BodyText)``;
export const ErrorMessage = styled(BodyText)``;

export const ErrorContainer = styled.div`
    &:not(:last-of-type) {
        margin-bottom: ${convertPxToRem({ px: 24 })};
    }
`;

export const ErrorModalButton = styled(Link).attrs({
    disableVisitedStyle: true,
    darkMode: true
})``;

export const MessageTextContainer = styled.span`
    ${ErrorModalButton} {
        margin-left: ${convertPxToRem({ px: 16 })};
    }
`;

export const BannerContainer = styled.div`
    position: absolute;
    bottom: 0;
`;
